import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormCheckClassAbstract } from '../../../abstract/form-check-class-abstract';

/**
 * A styled, accessible toggle switch built on {@link FormCheckClassAbstract} and
 * integrated with Angular Signal Forms.
 *
 * The component renders a pill-shaped toggle button. Visual state (on/off position and
 * colour) is driven by the `checked` model signal; clicking the pill flips it and emitting
 * `touch` on blur lets Signal Forms mark the field as touched.
 *
 * ---
 *
 * ### Inputs (own)
 *
 * None. Everything comes from the abstract base classes.
 *
 * ### Inputs (inherited from {@link FormCheckClassAbstract} / {@link FormControlStateAbstract})
 *
 * `checked`, `label`, `labelClass`, `ariaLabel`, `appliedClasses`, `name`, `required`,
 * `errors`, `pending`, `touched`, `dirty`, `disabled`.
 *
 * ### Outputs (inherited)
 *
 * `touch` – emitted on blur so Signal Forms marks the field as touched.
 *
 * ---
 *
 * @usageNotes
 *
 * #### With Signal Forms (`[formField]`)
 * ```html
 * <juno-libs-ui-toggle [formField]="settingsForm.notifications" label="SETTINGS.NOTIFICATIONS" />
 * ```
 *
 * #### Standalone two-way binding (`[(checked)]`)
 * ```html
 * <juno-libs-ui-toggle [(checked)]="isEnabled" label="SETTINGS.ENABLED" name="enabled" />
 * ```
 *
 * @see {@link FormCheckClassAbstract} for the inherited contract.
 * @see {@link JunoCheckbox} for the checkbox counterpart (use it when validation errors need
 *      to be displayed inline, e.g. a required "accept terms" field).
 */
@Component({
  selector: 'juno-libs-ui-toggle',
  imports: [TranslocoDirective],
  templateUrl: './juno-toggle.component.html',
})
export class JunoToggle extends FormCheckClassAbstract {}
